import {
  ECollectionRef,
  EOrganization,
  EQuery,
  ERef,
  ModularSize,
  ESnapshotExists
} from '../types';

export class ModularSizeService {
  constructor(private collection: ECollectionRef<ModularSize>) {}

  getActiveModularSizesQuery() {
    return this.collection.where('archived', '==', false);
  }

  getOwnedModularSizesQuery(org: ERef<EOrganization>) {
    return this.getActiveModularSizesQuery().where('owner', '==', org);
  }

  getAllowedModularSizesQuery(org: ERef<EOrganization>) {
    return this.getActiveModularSizesQuery().where(
      'publishers',
      'array-contains',
      org
    );
  }

  getPublisherOrgModularSizesQueries(org: ERef<EOrganization>): {
    ownedModularSizesQuery: EQuery<ModularSize>;
    allowedModularSizesQuery: EQuery<ModularSize>;
  } {
    const ownedModularSizesQuery = this.getOwnedModularSizesQuery(org);
    const allowedModularSizesQuery = this.getAllowedModularSizesQuery(org);

    return {
      ownedModularSizesQuery,
      allowedModularSizesQuery
    };
  }

  deduplicateModularSizes(allSizes: ESnapshotExists<ModularSize>[]) {
    return allSizes.filter(
      (modularSize, index) =>
        allSizes.findIndex(ms => ms.id === modularSize.id) === index
    );
  }

  async getPublisherOrgModularSizes(
    org?: ERef<EOrganization>
  ): Promise<ESnapshotExists<ModularSize>[]> {
    if (!org) {
      return [];
    }

    const { ownedModularSizesQuery, allowedModularSizesQuery } =
      this.getPublisherOrgModularSizesQueries(org);

    const [ownedSnapshot, allowedSnapshot] = await Promise.all([
      ownedModularSizesQuery.get(),
      allowedModularSizesQuery.get()
    ]);

    const allModularSizes = [...ownedSnapshot.docs, ...allowedSnapshot.docs];

    return this.deduplicateModularSizes(allModularSizes);
  }
}
